<form>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showDialpad">
         <input
            type="checkbox"
            id="showDialpad"
            [checked]="showOwnAgent$ | async"
            (click)="changeShowOwnAgent($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.agent_list.settings.show_own_agent_label' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.agent_list.settings.group_ids_for_agent_list_label' | translate }}</label>

      <kendo-multiselect
         class="k-form-field sam-form-control sam-form-control-full-width"
         [data]="availableUserGroups$ | async"
         [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }"
         [popupSettings]="{ popupClass: 'hide-selected-items' }"
         [value]="groupIdsForAgentList$ | async"
         (valueChange)="groupIdsForAgentListChanged($event)"
         valueField="id"
         [valuePrimitive]="true"
         textField="name"
         [placeholder]="'brick.brick_definitions.agent_list.settings.show_agents_from_all_groups' | translate"
      ></kendo-multiselect>
   </div>
</form>
